import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HistoriesView from "@/views/HistoriesView.vue";
import CurrentView from "@/views/CurrentView.vue";
import SettingsView from "@/views/SettingsView.vue";
import LoginView from "@/views/LoginView.vue";
import UserRegisterView from "@/views/UserRegisterView.vue";
import PasswordReminderView from "@/views/PasswordReminderView.vue";
import PasswordReminderResetView from "@/views/PasswordReminderResetView.vue";
import UserRegisterInfoView from "@/views/UserRegisterInfoView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/menu',
    name: 'menu',
    component: HomeView
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/exam',
    name: 'exam',
    component: CurrentView
  },
  {
    path: '/histories',
    name: 'histories',
    component: HistoriesView
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView
  },
  {
    path: '/logout',
    name: 'logout',
    component: LoginView
  },
  {
    path: '/toroku',
    name: 'toroku',
    component: UserRegisterView
  },
  {
    path: '/torokuannai',
    name: 'torokuannai',
    component: UserRegisterInfoView
  },
  {
    path: '/passwordReminder',
    name: 'passwordReminder',
    component: PasswordReminderView
  },
  {
    path: '/passwordReminderReset',
    name: 'passwordReminderReset',
    component: PasswordReminderResetView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
